var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"google-pay-btn",class:{'google-pay-btn--disabled': _vm.isDisabled},attrs:{"aria-label":"Google Pay"},on:{"click":_vm.googlePayClick}},[_c('img',{staticClass:"google-pay-btn__img",attrs:{"src":_vm.googleBtnImage}})])
}
var staticRenderFns = []

export { render, staticRenderFns }